import {
    iconClient,
    iconCalculator,
    iconReportsDefault,
    iconSearch,
    iconReports,
    iconPayment,
    iconAddDocsPayment,
    icondual,
    iconindividual,
    iconWarranty,
    iconHandshake,
    iconFinancies,
    iconAddDocs,
    iconCreditsMonotoring,
    iconConsults,
    iconRequest,
    iconDigitalSignature
} from '../defaultValues';

const data = {
    role_0f957f5c5267437b8159c96147745c40: [

        {
            id: 'credits',
            icon: iconCreditsMonotoring,
            label: 'Solicitudes de crédito',
            subs: [
                {
                    id: 'gogo',
                    icon: iconRequest,
                    label: 'Gestionar',
                    to: '/app/credits',
                },
                {
                    id: 'gogo',
                    icon: iconCreditsMonotoring,
                    label: 'Consultar',
                    to: '/app/consultRequest',
                },
                {
                    id: 'searcRequest',
                    icon: iconSearch,
                    label: 'Buscar',
                    to: '/app/reports/searchRequest',
                },
               
                {
                    id: 'comercialMonotoring',
                    icon: iconConsults,
                    label: 'Seguimiento Comercial',
                    to: '/app/ComercialMonotoring',
                },

            ],
        },
        {
            id: 'simulador-credito',
            icon: iconCalculator,
            label: 'Simulador de Crédito',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconCalculator,
                    label: 'Simulador de Créditos',
                    to: '/app/calculator',
                },
                {
                    icon: iconCalculator,
                    label: 'Calculadora R&R',
                    to: '/app/reports/calculatorRefinancing',
                },
            ],
        },

        {
            id: 'secondmenu',
            icon: iconClient,
            label: 'Clientes',
            to: '/app/clients',
        },
        {
            icon: iconDigitalSignature,
            label: 'Firma Electrónica',
            to: '/app/electronicSignature/ElectronicSignature',
        },
        {
            id: 'cartera',
            icon: iconReportsDefault,
            label: 'Cartera',
            to: '/app/calculator',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Mora',
                    to: '/app/collection/lista',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Par1 & Par30',
                    to: '/app/collection/per1AndPer30',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Cartera',
                    to: '/app/collection/per1AndPer30Comparative',
                },
            ],
        },
        {
            id: 'wompi',
            icon: iconFinancies,
            label: 'Wompi',
            to: '/app/WompiExecutive',
        },
        {
            id: 'financialSolutions',
            icon: iconHandshake,
            label: 'Soluciones Financieras',
            subs: [
                {
                    id: 'gestiona-soluciones-financieras',
                    icon: iconReportsDefault,
                    label: 'Gestionar',
                    to: '/app/financialSolutions/list',
                },
                {
                    id: 'consulta-soluciones-financieras',
                    icon: iconReportsDefault,
                    label: 'Consultar',
                    to: '/app/financialSolutionsConsults/list',
                },
            ],
        },
        {
            id: 'cobranza',
            icon: iconPayment,
            label: 'Cobranza',
            to: '/app/calculator',
            subs: [
                {
                    id: 'signautre',
                    icon: icondual,
                    label: 'Consultar',
                    to: '/app/consultPayment',
                },
                {
                    id: 'signautre',
                    icon: iconAddDocsPayment,
                    label: 'Adjuntar',
                    to: '/app/signaturePayment',
                },
                {
                    id: 'payment',
                    icon: iconReportsDefault,
                    label: 'Generar',
                    to: '/app/paymentDocument',
                    subs: [
                        {
                            id: 'payment',
                            icon: iconindividual,
                            label: 'Individual',
                            to: '/app/paymentDocument',
                        },
                        {
                            id: 'signautre',
                            icon: icondual,
                            label: 'Masivo',
                            to: '/app/massivePaymentDocument',
                        },
                    ],
                },
            ],
        },
        {
            id: 'neww',
            icon: iconWarranty,
            label: 'Garantía Vehicular',
            to: '/app/radicationWarranty',
        },
        {
            id: 'runtPreRegistration',
            icon: iconAddDocs,
            label: 'Pre registro RUNT',
            to: '/app/credits/RuntPreRegistration',
        },


        {
            id: 'blankpage',
            icon: iconReports,
            label: 'Reportes',
            to: '/app/reports',
            subs: [
                {
                    icon: iconReportsDefault,
                    label: 'Generales',
                    to: '/app/reports/reportsDisbursement',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Desempeño Ejecutivos',
                    to: '/app/reports/teamPerformanceExecutive',
                },
                {
                    icon: iconReportsDefault,
                    label: 'Comparativo Productividad',
                    to: '/app/reports/productivityComparative',
                },
                {
                    id: 'seguimiento',
                    icon: iconReportsDefault,
                    label: 'Seguimiento',
                    to: '/app/reports/reportsRequestTracking',
                },
            ],
        },
        

      

    ],
};
export default data;
